import { jsxs as s, jsx as e, Fragment as u } from "react/jsx-runtime";
import { useTranslation as x, cents as _, FieldLabel as c, centsToUnits as g } from "@systemeio/ui";
import { twJoin as b } from "tailwind-merge";
import { CurrencyBadge as y } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as S } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as w } from "../../../../../providers/use-locale-provider.mjs";
import { usePhysicalProductStore as N, useOfferStore as T } from "../../../../../store/index.mjs";
import { calculateShippingTotal as v } from "../../utils/calculate-shipping.mjs";
import { Product as j } from "./product.mjs";
import { ShippingSummary as A } from "./shipping-summary.mjs";
const k = ({ product: n, calculatePrice: t, isLoading: m }) => {
  const { t: o } = x(), { locale: l } = w(), { selectedShipping: a } = N(), { finalAmount: f } = T(), r = !!a, i = !!(t != null && t.tax) && t.tax.rate > 0, h = r ? v(a, (t == null ? void 0 : t.tax.rate) ?? 0) : 0, p = _(Math.ceil(f ?? 0) + h), d = () => o(!i && !r ? "public_pages_purchase.total" : i && !r ? "public_pages_purchase.total_amount_with_tax" : !i && r ? "public_pages_purchase.total_amount_with_shipping" : "public_pages_purchase.total_amount_with_tax_and_shipping");
  return /* @__PURE__ */ s("div", { className: b("flex flex-col gap-1", m && "animate-pulse"), children: [
    /* @__PURE__ */ e(c, { label: o("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ s("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      /* @__PURE__ */ e(j, { product: n, calculatePrice: t }),
      r && /* @__PURE__ */ e(
        A,
        {
          product: n,
          selectedShipping: a,
          calculatePrice: t
        }
      ),
      p > 0 && /* @__PURE__ */ s(u, { children: [
        /* @__PURE__ */ e("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
        /* @__PURE__ */ s("div", { className: "flex w-full items-center justify-between", children: [
          /* @__PURE__ */ e("span", { className: "text-[14px] font-bold", children: d() }),
          /* @__PURE__ */ s("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ e(y, { currency: n.currency }),
            /* @__PURE__ */ e("span", { className: "text-[14px] font-bold", children: S(
              g(p),
              n.currency,
              l
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
};
export {
  k as OrderSummary
};
